import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';
import { Fancybox } from "@fancyapps/ui";
import {initSimilarProjectSlider} from '../sections/similar-project';
import "@fancyapps/ui/dist/fancybox/fancybox.css";
gsap.registerPlugin(ScrollTrigger,ScrollToPlugin);

//event document ready function
document.addEventListener("DOMContentLoaded", (event) => {
  projectBanner();
  projectGallery(); 
  initSimilarProjectSlider();
})

window.addEventListener('resize', projectGallery);

function projectBanner(){
  // Create a timeline
  const timeline = gsap.timeline({
    scrollTrigger: {
      trigger: '.project-header',
      start: 'top top', // Start when the element hits the top of the viewport
      end: 'bottom top', // End when the bottom of the element hits the top of the viewport
      scrub: true, // Smoothly link animation to scroll
      pin: true, // Pin the element during the animation
    }
  });

  timeline
    .fromTo(
        '.project-header__image-container',
        { width: '50%', height: '50%' }, // Initial size
        { width: '100%', height: '100%' } // Target size
    )
    .to(
        '.project-header__overlay',
        { opacity: 0.7, duration: 1 }, "-=0.5" // Change content color to black
    )
    .to(
        '.project-header__info-container',
        { color: 'white', duration: 1 }, "-=0.5" // Change content color to white
    );
}

function projectGallery(){
  let grid = document.querySelector('.grid');
  
  // Set gutter depending on the screen size
  let gutterSize = 10;
  if(window.innerWidth <= 1399){
    gutterSize = 10;
  }
  if(window.innerWidth <= 991){
    gutterSize = 10;
  }
  if(window.innerWidth <= 768){
    gutterSize = 10;
  }
  
  let msnry = new Masonry( grid, {
    itemSelector: '.grid-item',
    columnWidth: '.grid-sizer',
    percentPosition: true,
    gutter: gutterSize
  });
  
  imagesLoaded( grid ).on( 'progress', function() {
    // layout Masonry after each image loads
    msnry.layout();
  });
  Fancybox.bind('[data-fancybox="gallery"]', {
    hideScrollbar: true,
    Thumbs: true,
    Toolbar: {
        display: {
          right: ["slideshow", "thumbs", "close"],
        },
    },
});
}
